<template>
  <div v-if="data3" id="main3" ref="main3" style="width: 100%;"></div>
  <no-data-temporarily v-else style="width: 100%;"></no-data-temporarily>
</template>
<script>
import NoDataTemporarily from '@/components/utils/no-data-temporarily.vue';
import { initResizeListener } from '@/utils/utils';

export default {
  components: {
    NoDataTemporarily,
  },
  data() {
    return {
      myChart3: null,
    };
  },
  props: {
    data3: Object,
  },
  watch: {
    data3() {
      this.initData();
    },
    skinType() {
      this.initData();
    },
  },
  mounted() {
    this.initData();
  },
  computed: {
    skinType() {
      return this.$store.getters.skinType;
    },
  },
  methods: {
    // 初始化数据
    initData() {
      // 基于准备好的dom，初始化echarts实例
      if (this.myChart3 === null) {
        this.myChart3 = this.$echarts.init(this.$refs.main3);
        initResizeListener(this.myChart3, this.$refs.main3);
      }
      if (this.data3.length === 0) {
        this.myChart3.clear();
      } else {
        const option1 = {
          tooltip: {},
          // 控制图标的大小
          grid: {
            top: '40',
            left: '10',
            right: '20',
            bottom: '20',
            containLabel: true,
          },
          legend: {
            top: '5',
            textStyle: {
              color: 'auto',
            },
          },
          xAxis: [
            {
              type: 'category',
              data: this.data3.xAxisData,
              axisLine: {
                color: this.skinType ? '#fff' : '#333',
              },
              axisLabel: {
                color: this.skinType ? '#fff' : '#333',
              },
            },
          ],
          yAxis: [
            {
              type: 'value',
              name: '负荷(kW)',
              nameTextStyle: {
                color: this.skinType ? '#fff' : '#333',
              },
              axisLabel: {
                color: this.skinType ? '#fff' : '#333',
              },
              axisLine: {
                color: this.skinType ? '#fff' : '#333',
              },
              splitLine: {
                lineStyle: {
                  color: '#ccc',
                  type: 'dashed',
                },
              },
            },
            {
              type: 'value',
              name: '负载率(%)',
              nameTextStyle: {
                color: this.skinType ? '#fff' : '#333',
              },
              axisLabel: {
                color: this.skinType ? '#fff' : '#333',
              },
              axisLine: {
                color: this.skinType ? '#fff' : '#333',
              },
              splitLine: {
                lineStyle: {
                  color: '#ccc',
                  type: 'dashed',
                },
              },
            },
          ],
          series: [
            {
              name: '负荷',
              type: 'bar',
              yAxisIndex: 0,
              barWidth: '10%', // 柱图宽度,
              data: this.data3.seriesData[0].Data,
            },
            {
              name: '负载率',
              type: 'bar',
              yAxisIndex: 1,
              barWidth: '10%', // 柱图宽度
              data: this.data3.seriesData[1].Data,
            },
          ],
          color: [
            '#FFAF8E',
            '#667EEB',
            '#75B2FB',
            '#08BED3',
            '#F67CA3',
            '#7FC4C2',
            '#7a81b5'],
        };
        this.myChart3.setOption(option1, true);
      }
    },
  },
};
</script>
